import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import GoogleIcon from "@mui/icons-material/Google";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { AuthBrand, AuthCard } from "~/components/AuthCard";
import Logo from "~/shared/ui/brand/Logo";
import { googleRedirectUrl } from "~/services/auth";
import { navigateTo } from "~/utils/navigation";
import { COLORS } from "~/ui/tokens";
import { usePageTitle } from "~/shared/ui/usePageTitle";

export default function Login() {
  usePageTitle("Entrar");
  const { token } = useParams();
  const [connecting, setConnecting] = useState(false);

  useEffect(() => {
    // Botão Voltar depois de ir ao Google restaura a página do bfcache com o spinner: reabre o botão.
    const onPageShow = (event) => {
      if (event.persisted) setConnecting(false);
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, []);

  const start = () => {
    setConnecting(true);
    navigateTo(googleRedirectUrl(token));
  };

  if (connecting) {
    return (
      <AuthCard maxWidth={300}>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}><Logo variant="horizontal" height={32} /></Box>
        <CircularProgress sx={{ color: COLORS.accent, mb: 3 }} aria-label="Conectando ao Google…" />
        <Typography sx={{ fontWeight: 600 }}>Conectando ao Google…</Typography>
        <Typography variant="body2" sx={{ color: COLORS.muted }}>Conclua o login na janela do Google.</Typography>
      </AuthCard>
    );
  }

  return (
    <AuthCard>
      <AuthBrand />
      <Divider sx={{ my: 3 }} />
      {token && (
        <Alert severity="info" sx={{ mb: 2, textAlign: "left" }}>
          Você recebeu um convite. Entre com a conta Google do e-mail convidado.
        </Alert>
      )}
      <Button
        fullWidth
        size="large"
        variant="outlined"
        startIcon={<GoogleIcon />}
        onClick={start}
        sx={{ color: COLORS.text, borderColor: "#d1d5db", textTransform: "none", fontSize: 16, py: 1.25 }}
      >
        Entrar com Google
      </Button>
      <Typography variant="caption" component="p" sx={{ color: COLORS.muted, mt: 2, display: "flex", gap: 0.5, justifyContent: "center", alignItems: "flex-start" }}>
        <LockOutlinedIcon sx={{ fontSize: 15 }} aria-hidden />
        <span>Acesso somente por convite. Use seu e-mail corporativo.</span>
      </Typography>
    </AuthCard>
  );
}
